import {useMemo} from 'react'

const useProductCertificates = (product) => {
    return useMemo(
        () =>
            (product?.c_localCertificates || [])
                .concat(product?.c_globalCertificates || [])
                .filter((certificate) => !!certificate),
        [product?.c_localCertificates, product?.c_globalCertificates]
    )
}

export default useProductCertificates
